import { formatPhoneNumber, isPhoneNumberValue } from '@/lib/crm/utils/phone';

/**
 * What an overview row's copy control puts on the clipboard for a property
 * value, or '' when the row should offer no copy control.
 *
 * A row copies exactly one thing. A single value — a plain string, a phone
 * number in its canonical shape, or a multi-value field holding one entry —
 * is copied as the user reads it (the phone formatted, not its parts). A
 * multi-value field holding several entries gets no row control: there is no
 * single answer to "copy this", so each value keeps its own affordance.
 */
export function getRowCopyText(value: unknown): string {
  let single: unknown = value;
  if (Array.isArray(value)) {
    single = value.length === 1 ? value[0] : undefined;
  }
  if (typeof single === 'string') {
    return single.trim();
  }
  if (isPhoneNumberValue(single)) {
    return formatPhoneNumber(single);
  }
  return '';
}
